import { useMemo } from 'react';
import { useApprovalContext } from './useApprovalContext';
export const useApproversInfo = () => {
  const approval = useApprovalContext();
  const approverOwnerIds = useMemo(() => {
    if (!approval.data) {
      return [];
    }
    return approval.data.approvalSteps.map(step => step.approver.ownerId);
  }, [approval.data]);
  const {
    approvedApproverOwnerIds,
    approvedApproverUserIds
  } = useMemo(() => {
    if (!approval.data) {
      return {
        approvedApproverOwnerIds: [],
        approvedApproverUserIds: []
      };
    }
    const approvedSteps = approval.data.approvalSteps.filter(step => step.approvalStepStatus === 'APPROVED');
    return {
      approvedApproverOwnerIds: approvedSteps.map(step => step.approver.ownerId),
      approvedApproverUserIds: approvedSteps.map(step => step.approver.activeUserId)
    };
  }, [approval.data]);
  return {
    approverOwnerIds,
    approvedApproverOwnerIds,
    approvedApproverUserIds
  };
};